import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    underLine: {
        textDecoration: 'underline',
    },
    elipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:not(:last-child)': {
            paddingBottom: '8px',
        },
    },
}));
